<script setup lang="ts">
import {User} from "@/types";
import {useUserAvatar} from "@/composables/avatar";

interface Props {
  user: User
}

const props = defineProps<Props>()
</script>

<template>
    <v-list-item>
        <template #prepend>
            <v-avatar
                size="24"
                rounded="xl"
                class="border-sm"
            >
                <v-img
                    :src="useUserAvatar(props.user.name)"
                    contain
                />
            </v-avatar>
        </template>
        <template #title>
            <span class="text-body-2 font-weight-bold">
                {{ props.user.name }}
            </span>
        </template>
    </v-list-item>
</template>

<style scoped>
:deep(.v-list-item__prepend) {
  width: 35px;
}
</style>
